import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addVehicle = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehiclecreation`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const searchVehicle = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehicledetail/search`,
      data,
    );
    return response.data !== null ? response.data : [];
  } catch (e) {
    console.error(e);
  }
};

export const vehicleById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehiclecreation/${id}`,
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};

export const vehiclesByMultipleIds = async (ids) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehiclecreation/vehicles`,
      ids,
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};

export const vehicleByVehNo = async (vehNo,company) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehiclecreation/vehicle-no/${vehNo}`,
      {
        params: {
          company,
        },
      }
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateVehicle = async (data) => {
  try {
    const res = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehiclecreation`,
      data,
    );
    return res;
  } catch (e) {
    console.error(e);
  }
};

export const vehicleTypeById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehicletype/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getVehicleDetailsDownload = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehiclecreation/vehicles/excel`,
      data,
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const bulkVehicleStatusChange = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehicledetail/bulk-status`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Bulk update error:", error);
    throw error;
  }
};


export const syncVehicle = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.LOCATION}/manual-sync`,
      data,
    );

    return response.data;
  } catch (e) {
    console.error(e);
    return "FAILED|Manual vehicle sync failed";
  }
};